import React from "react";
import styles from "./Overlay.css";
import Scrollable from "../Scrollable/Scrollable";

const Overlay = ({ show = false, onTop = true, children }) =>
  show && (
    <Scrollable className={`${styles.overlay} ${onTop && styles.onTop}`}>
      <div className={styles.container}>{children}</div>
    </Scrollable>
  );

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay/Overlay.js